import { CreateLegalEntityCommandDto } from 'api/actor';
import { ReferentialKey } from 'api/referential';
import { LegalEntityFormValues } from 'features/new-actor/types/optim/legalEntityFormValues';
import { mapLegalEntityContactFormValues } from './mapLegalEntityContactFormValues';

export function mapLegalEntityFormValues(
  values: LegalEntityFormValues,
  referentialsData: any,
): CreateLegalEntityCommandDto {
  const {
    postalCode,
    googlePlaceId,
    city,
    country,
    address,
    additionalAddress,
    latitude,
    longitude,
    phone,
    email,
    companyName,
    legalReason,
    rcsCity,
    rcsNumber,
    rcp,
    oriasNumber,
    capital,
    registrationNumber,
    id,
    contacts
  } = values;

  const getLegalFormId = (key: string) => {
    const data = referentialsData[ReferentialKey.LegalForm].find((item: any) => item.code === key);
    return data ? (data.id as string) : '';
  };

  const naturalPersons = contacts && contacts.map(contact => mapLegalEntityContactFormValues(contact, referentialsData))

  return {
    id,
    rcp: rcp,
    companyName,
    legalFormId: getLegalFormId(legalReason),
    rcsCity,
    rcsNumber,
    oriasNumber,
    capital,
    phone,
    email,
    registrationNumber,
    naturalPersons,
    address: {
      line1: address,
      line2: (additionalAddress || '').trim(),
      line3: undefined,
      zipCode: postalCode,
      city,
      country,
      formattedAddress: `${address},${city},${country}`,
      latitude: latitude || undefined,
      longitude: longitude || undefined,
      googlePlaceId: googlePlaceId || undefined
    },
  };
}
